/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AuthenticationRouteImport } from './routes/authentication'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAiBudgetRouteImport } from './routes/admin.ai-budget'
import { Route as AdminAnalyticsRouteImport } from './routes/admin.analytics'
import { Route as AdminCmsUsersRouteImport } from './routes/admin.cms-users'
import { Route as AdminFeatureFlagsRouteImport } from './routes/admin.feature-flags'
import { Route as AdminFinanceRouteImport } from './routes/admin.finance'
import { Route as AdminHelpKbRouteImport } from './routes/admin.help-kb'
import { Route as AdminMemoryHealthRouteImport } from './routes/admin.memory-health'
import { Route as AdminProfileRouteImport } from './routes/admin.profile'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminSubscriptionsRouteImport } from './routes/admin.subscriptions'
import { Route as AdminSystemHealthRouteImport } from './routes/admin.system-health'
import { Route as AuthenticationChangePasswordRouteImport } from './routes/authentication.change-password'
import { Route as AuthenticationEmailConfirmRouteImport } from './routes/authentication.email-confirm'
import { Route as AuthenticationForgotPasswordRouteImport } from './routes/authentication.forgot-password'
import { Route as AuthenticationLoginRouteImport } from './routes/authentication.login'
import { Route as AuthenticationMfaRouteImport } from './routes/authentication.mfa'
import { Route as AuthenticationOauthCallbackRouteImport } from './routes/authentication.oauth-callback'
import { Route as AuthenticationResetPasswordRouteImport } from './routes/authentication.reset-password'
import { Route as AuthenticationSetCmsPasswordRouteImport } from './routes/authentication.set-cms-password'
import { Route as AuthenticationSetPasswordRouteImport } from './routes/authentication.set-password'
import { Route as AuthenticationSignupRouteImport } from './routes/authentication.signup'
import { Route as AuthenticationVerifyEmailRouteImport } from './routes/authentication.verify-email'
import { Route as AdminFinanceIndexRouteImport } from './routes/admin.finance.index'
import { Route as AdminFormBuilderIndexRouteImport } from './routes/admin.form-builder.index'
import { Route as AdminFormBuilderTemplateIdRouteImport } from './routes/admin.form-builder.$templateId'
import { Route as AdminHelpKbIndexRouteImport } from './routes/admin.help-kb.index'
import { Route as AdminHelpKbMediaRouteImport } from './routes/admin.help-kb.media'
import { Route as AdminHelpKbNewRouteImport } from './routes/admin.help-kb.new'
import { Route as AdminHelpKbQueriesRouteImport } from './routes/admin.help-kb.queries'
import { Route as AdminOrganizationsIndexRouteImport } from './routes/admin.organizations.index'
import { Route as AdminOrganizationsOrgIdRouteImport } from './routes/admin.organizations.$orgId'
import { Route as AdminSubscriptionsIndexRouteImport } from './routes/admin.subscriptions.index'
import { Route as AdminSubscriptionsAuditRouteImport } from './routes/admin.subscriptions.audit'
import { Route as AdminSubscriptionsDiscountsRouteImport } from './routes/admin.subscriptions.discounts'
import { Route as AdminSubscriptionsFraudRouteImport } from './routes/admin.subscriptions.fraud'
import { Route as AdminSubscriptionsRevenueRouteImport } from './routes/admin.subscriptions.revenue'
import { Route as AdminSubscriptionsStripeEventsRouteImport } from './routes/admin.subscriptions.stripe-events'
import { Route as AdminSubscriptionsSyncRouteImport } from './routes/admin.subscriptions.sync'
import { Route as AdminSupportIndexRouteImport } from './routes/admin.support.index'
import { Route as AdminSupportTicketIdRouteImport } from './routes/admin.support.$ticketId'
import { Route as AdminTeamsIndexRouteImport } from './routes/admin.teams.index'
import { Route as AdminTeamsTeamIdRouteImport } from './routes/admin.teams.$teamId'
import { Route as AdminUsersIndexRouteImport } from './routes/admin.users.index'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin.users.$userId'
import { Route as AdminUsersUnverifiedRouteImport } from './routes/admin.users.unverified'
import { Route as AdminFinanceBankProviderCredentialsIndexRouteImport } from './routes/admin.finance.bank-provider-credentials.index'
import { Route as AdminFinanceReferenceAccountsIndexRouteImport } from './routes/admin.finance.reference-accounts.index'
import { Route as AdminFinanceReferenceAccountsTemplateIdRouteImport } from './routes/admin.finance.reference-accounts.$templateId'
import { Route as AdminFinanceReferenceAccountsNewRouteImport } from './routes/admin.finance.reference-accounts.new'
import { Route as AdminHelpKbArticleIdEditRouteImport } from './routes/admin.help-kb.$articleId.edit'
import { Route as AdminSubscriptionsAddonsIndexRouteImport } from './routes/admin.subscriptions.addons.index'
import { Route as AdminSubscriptionsAddonsAddonKeyRouteImport } from './routes/admin.subscriptions.addons.$addonKey'
import { Route as AdminSubscriptionsPlansIndexRouteImport } from './routes/admin.subscriptions.plans.index'
import { Route as AdminSubscriptionsPlansPlanIdRouteImport } from './routes/admin.subscriptions.plans.$planId'
import { Route as AdminFinanceReferenceAccountsTemplateIdIndexRouteImport } from './routes/admin.finance.reference-accounts.$templateId.index'
import { Route as AdminFinanceReferenceAccountsTemplateIdEditRouteImport } from './routes/admin.finance.reference-accounts.$templateId.edit'
import { Route as AdminFinanceReferenceAccountsTemplateIdAccountsNewRouteImport } from './routes/admin.finance.reference-accounts.$templateId.accounts.new'
import { Route as AdminFinanceReferenceAccountsTemplateIdAccountsAccountIdEditRouteImport } from './routes/admin.finance.reference-accounts.$templateId.accounts.$accountId.edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticationRoute = AuthenticationRouteImport.update({
  id: '/authentication',
  path: '/authentication',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAiBudgetRoute = AdminAiBudgetRouteImport.update({
  id: '/ai-budget',
  path: '/ai-budget',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCmsUsersRoute = AdminCmsUsersRouteImport.update({
  id: '/cms-users',
  path: '/cms-users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeatureFlagsRoute = AdminFeatureFlagsRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFinanceRoute = AdminFinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => AdminRoute,
} as any)
const AdminHelpKbRoute = AdminHelpKbRouteImport.update({
  id: '/help-kb',
  path: '/help-kb',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMemoryHealthRoute = AdminMemoryHealthRouteImport.update({
  id: '/memory-health',
  path: '/memory-health',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProfileRoute = AdminProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSubscriptionsRoute = AdminSubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSystemHealthRoute = AdminSystemHealthRouteImport.update({
  id: '/system-health',
  path: '/system-health',
  getParentRoute: () => AdminRoute,
} as any)
const AuthenticationChangePasswordRoute =
  AuthenticationChangePasswordRouteImport.update({
    id: '/change-password',
    path: '/change-password',
    getParentRoute: () => AuthenticationRoute,
  } as any)
const AuthenticationEmailConfirmRoute =
  AuthenticationEmailConfirmRouteImport.update({
    id: '/email-confirm',
    path: '/email-confirm',
    getParentRoute: () => AuthenticationRoute,
  } as any)
const AuthenticationForgotPasswordRoute =
  AuthenticationForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => AuthenticationRoute,
  } as any)
const AuthenticationLoginRoute = AuthenticationLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthenticationRoute,
} as any)
const AuthenticationMfaRoute = AuthenticationMfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => AuthenticationRoute,
} as any)
const AuthenticationOauthCallbackRoute =
  AuthenticationOauthCallbackRouteImport.update({
    id: '/oauth-callback',
    path: '/oauth-callback',
    getParentRoute: () => AuthenticationRoute,
  } as any)
const AuthenticationResetPasswordRoute =
  AuthenticationResetPasswordRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => AuthenticationRoute,
  } as any)
const AuthenticationSetCmsPasswordRoute =
  AuthenticationSetCmsPasswordRouteImport.update({
    id: '/set-cms-password',
    path: '/set-cms-password',
    getParentRoute: () => AuthenticationRoute,
  } as any)
const AuthenticationSetPasswordRoute =
  AuthenticationSetPasswordRouteImport.update({
    id: '/set-password',
    path: '/set-password',
    getParentRoute: () => AuthenticationRoute,
  } as any)
const AuthenticationSignupRoute = AuthenticationSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthenticationRoute,
} as any)
const AuthenticationVerifyEmailRoute =
  AuthenticationVerifyEmailRouteImport.update({
    id: '/verify-email',
    path: '/verify-email',
    getParentRoute: () => AuthenticationRoute,
  } as any)
const AdminFinanceIndexRoute = AdminFinanceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminFinanceRoute,
} as any)
const AdminFormBuilderIndexRoute = AdminFormBuilderIndexRouteImport.update({
  id: '/form-builder/',
  path: '/form-builder/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFormBuilderTemplateIdRoute =
  AdminFormBuilderTemplateIdRouteImport.update({
    id: '/form-builder/$templateId',
    path: '/form-builder/$templateId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminHelpKbIndexRoute = AdminHelpKbIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminHelpKbRoute,
} as any)
const AdminHelpKbMediaRoute = AdminHelpKbMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => AdminHelpKbRoute,
} as any)
const AdminHelpKbNewRoute = AdminHelpKbNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AdminHelpKbRoute,
} as any)
const AdminHelpKbQueriesRoute = AdminHelpKbQueriesRouteImport.update({
  id: '/queries',
  path: '/queries',
  getParentRoute: () => AdminHelpKbRoute,
} as any)
const AdminOrganizationsIndexRoute = AdminOrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrganizationsOrgIdRoute = AdminOrganizationsOrgIdRouteImport.update({
  id: '/organizations/$orgId',
  path: '/organizations/$orgId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSubscriptionsIndexRoute = AdminSubscriptionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminSubscriptionsRoute,
} as any)
const AdminSubscriptionsAuditRoute = AdminSubscriptionsAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminSubscriptionsRoute,
} as any)
const AdminSubscriptionsDiscountsRoute =
  AdminSubscriptionsDiscountsRouteImport.update({
    id: '/discounts',
    path: '/discounts',
    getParentRoute: () => AdminSubscriptionsRoute,
  } as any)
const AdminSubscriptionsFraudRoute = AdminSubscriptionsFraudRouteImport.update({
  id: '/fraud',
  path: '/fraud',
  getParentRoute: () => AdminSubscriptionsRoute,
} as any)
const AdminSubscriptionsRevenueRoute =
  AdminSubscriptionsRevenueRouteImport.update({
    id: '/revenue',
    path: '/revenue',
    getParentRoute: () => AdminSubscriptionsRoute,
  } as any)
const AdminSubscriptionsStripeEventsRoute =
  AdminSubscriptionsStripeEventsRouteImport.update({
    id: '/stripe-events',
    path: '/stripe-events',
    getParentRoute: () => AdminSubscriptionsRoute,
  } as any)
const AdminSubscriptionsSyncRoute = AdminSubscriptionsSyncRouteImport.update({
  id: '/sync',
  path: '/sync',
  getParentRoute: () => AdminSubscriptionsRoute,
} as any)
const AdminSupportIndexRoute = AdminSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSupportTicketIdRoute = AdminSupportTicketIdRouteImport.update({
  id: '/support/$ticketId',
  path: '/support/$ticketId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTeamsIndexRoute = AdminTeamsIndexRouteImport.update({
  id: '/teams/',
  path: '/teams/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTeamsTeamIdRoute = AdminTeamsTeamIdRouteImport.update({
  id: '/teams/$teamId',
  path: '/teams/$teamId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersUnverifiedRoute = AdminUsersUnverifiedRouteImport.update({
  id: '/users/unverified',
  path: '/users/unverified',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFinanceBankProviderCredentialsIndexRoute =
  AdminFinanceBankProviderCredentialsIndexRouteImport.update({
    id: '/bank-provider-credentials/',
    path: '/bank-provider-credentials/',
    getParentRoute: () => AdminFinanceRoute,
  } as any)
const AdminFinanceReferenceAccountsIndexRoute =
  AdminFinanceReferenceAccountsIndexRouteImport.update({
    id: '/reference-accounts/',
    path: '/reference-accounts/',
    getParentRoute: () => AdminFinanceRoute,
  } as any)
const AdminFinanceReferenceAccountsTemplateIdRoute =
  AdminFinanceReferenceAccountsTemplateIdRouteImport.update({
    id: '/reference-accounts/$templateId',
    path: '/reference-accounts/$templateId',
    getParentRoute: () => AdminFinanceRoute,
  } as any)
const AdminFinanceReferenceAccountsNewRoute =
  AdminFinanceReferenceAccountsNewRouteImport.update({
    id: '/reference-accounts/new',
    path: '/reference-accounts/new',
    getParentRoute: () => AdminFinanceRoute,
  } as any)
const AdminHelpKbArticleIdEditRoute =
  AdminHelpKbArticleIdEditRouteImport.update({
    id: '/$articleId/edit',
    path: '/$articleId/edit',
    getParentRoute: () => AdminHelpKbRoute,
  } as any)
const AdminSubscriptionsAddonsIndexRoute =
  AdminSubscriptionsAddonsIndexRouteImport.update({
    id: '/addons/',
    path: '/addons/',
    getParentRoute: () => AdminSubscriptionsRoute,
  } as any)
const AdminSubscriptionsAddonsAddonKeyRoute =
  AdminSubscriptionsAddonsAddonKeyRouteImport.update({
    id: '/addons/$addonKey',
    path: '/addons/$addonKey',
    getParentRoute: () => AdminSubscriptionsRoute,
  } as any)
const AdminSubscriptionsPlansIndexRoute =
  AdminSubscriptionsPlansIndexRouteImport.update({
    id: '/plans/',
    path: '/plans/',
    getParentRoute: () => AdminSubscriptionsRoute,
  } as any)
const AdminSubscriptionsPlansPlanIdRoute =
  AdminSubscriptionsPlansPlanIdRouteImport.update({
    id: '/plans/$planId',
    path: '/plans/$planId',
    getParentRoute: () => AdminSubscriptionsRoute,
  } as any)
const AdminFinanceReferenceAccountsTemplateIdIndexRoute =
  AdminFinanceReferenceAccountsTemplateIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminFinanceReferenceAccountsTemplateIdRoute,
  } as any)
const AdminFinanceReferenceAccountsTemplateIdEditRoute =
  AdminFinanceReferenceAccountsTemplateIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AdminFinanceReferenceAccountsTemplateIdRoute,
  } as any)
const AdminFinanceReferenceAccountsTemplateIdAccountsNewRoute =
  AdminFinanceReferenceAccountsTemplateIdAccountsNewRouteImport.update({
    id: '/accounts/new',
    path: '/accounts/new',
    getParentRoute: () => AdminFinanceReferenceAccountsTemplateIdRoute,
  } as any)
const AdminFinanceReferenceAccountsTemplateIdAccountsAccountIdEditRoute =
  AdminFinanceReferenceAccountsTemplateIdAccountsAccountIdEditRouteImport.update(
    {
      id: '/accounts/$accountId/edit',
      path: '/accounts/$accountId/edit',
      getParentRoute: () => AdminFinanceReferenceAccountsTemplateIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/authentication': typeof AuthenticationRouteWithChildren
  '/admin/ai-budget': typeof AdminAiBudgetRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/cms-users': typeof AdminCmsUsersRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/finance': typeof AdminFinanceRouteWithChildren
  '/admin/help-kb': typeof AdminHelpKbRouteWithChildren
  '/admin/memory-health': typeof AdminMemoryHealthRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/subscriptions': typeof AdminSubscriptionsRouteWithChildren
  '/admin/system-health': typeof AdminSystemHealthRoute
  '/authentication/change-password': typeof AuthenticationChangePasswordRoute
  '/authentication/email-confirm': typeof AuthenticationEmailConfirmRoute
  '/authentication/forgot-password': typeof AuthenticationForgotPasswordRoute
  '/authentication/login': typeof AuthenticationLoginRoute
  '/authentication/mfa': typeof AuthenticationMfaRoute
  '/authentication/oauth-callback': typeof AuthenticationOauthCallbackRoute
  '/authentication/reset-password': typeof AuthenticationResetPasswordRoute
  '/authentication/set-cms-password': typeof AuthenticationSetCmsPasswordRoute
  '/authentication/set-password': typeof AuthenticationSetPasswordRoute
  '/authentication/signup': typeof AuthenticationSignupRoute
  '/authentication/verify-email': typeof AuthenticationVerifyEmailRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/form-builder/$templateId': typeof AdminFormBuilderTemplateIdRoute
  '/admin/help-kb/media': typeof AdminHelpKbMediaRoute
  '/admin/help-kb/new': typeof AdminHelpKbNewRoute
  '/admin/help-kb/queries': typeof AdminHelpKbQueriesRoute
  '/admin/organizations/$orgId': typeof AdminOrganizationsOrgIdRoute
  '/admin/subscriptions/audit': typeof AdminSubscriptionsAuditRoute
  '/admin/subscriptions/discounts': typeof AdminSubscriptionsDiscountsRoute
  '/admin/subscriptions/fraud': typeof AdminSubscriptionsFraudRoute
  '/admin/subscriptions/revenue': typeof AdminSubscriptionsRevenueRoute
  '/admin/subscriptions/stripe-events': typeof AdminSubscriptionsStripeEventsRoute
  '/admin/subscriptions/sync': typeof AdminSubscriptionsSyncRoute
  '/admin/support/$ticketId': typeof AdminSupportTicketIdRoute
  '/admin/teams/$teamId': typeof AdminTeamsTeamIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/users/unverified': typeof AdminUsersUnverifiedRoute
  '/admin/finance/': typeof AdminFinanceIndexRoute
  '/admin/form-builder/': typeof AdminFormBuilderIndexRoute
  '/admin/help-kb/': typeof AdminHelpKbIndexRoute
  '/admin/organizations/': typeof AdminOrganizationsIndexRoute
  '/admin/subscriptions/': typeof AdminSubscriptionsIndexRoute
  '/admin/support/': typeof AdminSupportIndexRoute
  '/admin/teams/': typeof AdminTeamsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/admin/finance/reference-accounts/$templateId': typeof AdminFinanceReferenceAccountsTemplateIdRouteWithChildren
  '/admin/finance/reference-accounts/new': typeof AdminFinanceReferenceAccountsNewRoute
  '/admin/help-kb/$articleId/edit': typeof AdminHelpKbArticleIdEditRoute
  '/admin/subscriptions/addons/$addonKey': typeof AdminSubscriptionsAddonsAddonKeyRoute
  '/admin/subscriptions/plans/$planId': typeof AdminSubscriptionsPlansPlanIdRoute
  '/admin/finance/bank-provider-credentials/': typeof AdminFinanceBankProviderCredentialsIndexRoute
  '/admin/finance/reference-accounts/': typeof AdminFinanceReferenceAccountsIndexRoute
  '/admin/subscriptions/addons/': typeof AdminSubscriptionsAddonsIndexRoute
  '/admin/subscriptions/plans/': typeof AdminSubscriptionsPlansIndexRoute
  '/admin/finance/reference-accounts/$templateId/edit': typeof AdminFinanceReferenceAccountsTemplateIdEditRoute
  '/admin/finance/reference-accounts/$templateId/': typeof AdminFinanceReferenceAccountsTemplateIdIndexRoute
  '/admin/finance/reference-accounts/$templateId/accounts/new': typeof AdminFinanceReferenceAccountsTemplateIdAccountsNewRoute
  '/admin/finance/reference-accounts/$templateId/accounts/$accountId/edit': typeof AdminFinanceReferenceAccountsTemplateIdAccountsAccountIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/authentication': typeof AuthenticationRouteWithChildren
  '/admin/ai-budget': typeof AdminAiBudgetRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/cms-users': typeof AdminCmsUsersRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/memory-health': typeof AdminMemoryHealthRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/system-health': typeof AdminSystemHealthRoute
  '/authentication/change-password': typeof AuthenticationChangePasswordRoute
  '/authentication/email-confirm': typeof AuthenticationEmailConfirmRoute
  '/authentication/forgot-password': typeof AuthenticationForgotPasswordRoute
  '/authentication/login': typeof AuthenticationLoginRoute
  '/authentication/mfa': typeof AuthenticationMfaRoute
  '/authentication/oauth-callback': typeof AuthenticationOauthCallbackRoute
  '/authentication/reset-password': typeof AuthenticationResetPasswordRoute
  '/authentication/set-cms-password': typeof AuthenticationSetCmsPasswordRoute
  '/authentication/set-password': typeof AuthenticationSetPasswordRoute
  '/authentication/signup': typeof AuthenticationSignupRoute
  '/authentication/verify-email': typeof AuthenticationVerifyEmailRoute
  '/admin': typeof AdminIndexRoute
  '/admin/form-builder/$templateId': typeof AdminFormBuilderTemplateIdRoute
  '/admin/help-kb/media': typeof AdminHelpKbMediaRoute
  '/admin/help-kb/new': typeof AdminHelpKbNewRoute
  '/admin/help-kb/queries': typeof AdminHelpKbQueriesRoute
  '/admin/organizations/$orgId': typeof AdminOrganizationsOrgIdRoute
  '/admin/subscriptions/audit': typeof AdminSubscriptionsAuditRoute
  '/admin/subscriptions/discounts': typeof AdminSubscriptionsDiscountsRoute
  '/admin/subscriptions/fraud': typeof AdminSubscriptionsFraudRoute
  '/admin/subscriptions/revenue': typeof AdminSubscriptionsRevenueRoute
  '/admin/subscriptions/stripe-events': typeof AdminSubscriptionsStripeEventsRoute
  '/admin/subscriptions/sync': typeof AdminSubscriptionsSyncRoute
  '/admin/support/$ticketId': typeof AdminSupportTicketIdRoute
  '/admin/teams/$teamId': typeof AdminTeamsTeamIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/users/unverified': typeof AdminUsersUnverifiedRoute
  '/admin/finance': typeof AdminFinanceIndexRoute
  '/admin/form-builder': typeof AdminFormBuilderIndexRoute
  '/admin/help-kb': typeof AdminHelpKbIndexRoute
  '/admin/organizations': typeof AdminOrganizationsIndexRoute
  '/admin/subscriptions': typeof AdminSubscriptionsIndexRoute
  '/admin/support': typeof AdminSupportIndexRoute
  '/admin/teams': typeof AdminTeamsIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/admin/finance/reference-accounts/new': typeof AdminFinanceReferenceAccountsNewRoute
  '/admin/help-kb/$articleId/edit': typeof AdminHelpKbArticleIdEditRoute
  '/admin/subscriptions/addons/$addonKey': typeof AdminSubscriptionsAddonsAddonKeyRoute
  '/admin/subscriptions/plans/$planId': typeof AdminSubscriptionsPlansPlanIdRoute
  '/admin/finance/bank-provider-credentials': typeof AdminFinanceBankProviderCredentialsIndexRoute
  '/admin/finance/reference-accounts': typeof AdminFinanceReferenceAccountsIndexRoute
  '/admin/subscriptions/addons': typeof AdminSubscriptionsAddonsIndexRoute
  '/admin/subscriptions/plans': typeof AdminSubscriptionsPlansIndexRoute
  '/admin/finance/reference-accounts/$templateId/edit': typeof AdminFinanceReferenceAccountsTemplateIdEditRoute
  '/admin/finance/reference-accounts/$templateId': typeof AdminFinanceReferenceAccountsTemplateIdIndexRoute
  '/admin/finance/reference-accounts/$templateId/accounts/new': typeof AdminFinanceReferenceAccountsTemplateIdAccountsNewRoute
  '/admin/finance/reference-accounts/$templateId/accounts/$accountId/edit': typeof AdminFinanceReferenceAccountsTemplateIdAccountsAccountIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/authentication': typeof AuthenticationRouteWithChildren
  '/admin/ai-budget': typeof AdminAiBudgetRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/cms-users': typeof AdminCmsUsersRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/finance': typeof AdminFinanceRouteWithChildren
  '/admin/help-kb': typeof AdminHelpKbRouteWithChildren
  '/admin/memory-health': typeof AdminMemoryHealthRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/subscriptions': typeof AdminSubscriptionsRouteWithChildren
  '/admin/system-health': typeof AdminSystemHealthRoute
  '/authentication/change-password': typeof AuthenticationChangePasswordRoute
  '/authentication/email-confirm': typeof AuthenticationEmailConfirmRoute
  '/authentication/forgot-password': typeof AuthenticationForgotPasswordRoute
  '/authentication/login': typeof AuthenticationLoginRoute
  '/authentication/mfa': typeof AuthenticationMfaRoute
  '/authentication/oauth-callback': typeof AuthenticationOauthCallbackRoute
  '/authentication/reset-password': typeof AuthenticationResetPasswordRoute
  '/authentication/set-cms-password': typeof AuthenticationSetCmsPasswordRoute
  '/authentication/set-password': typeof AuthenticationSetPasswordRoute
  '/authentication/signup': typeof AuthenticationSignupRoute
  '/authentication/verify-email': typeof AuthenticationVerifyEmailRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/form-builder/$templateId': typeof AdminFormBuilderTemplateIdRoute
  '/admin/help-kb/media': typeof AdminHelpKbMediaRoute
  '/admin/help-kb/new': typeof AdminHelpKbNewRoute
  '/admin/help-kb/queries': typeof AdminHelpKbQueriesRoute
  '/admin/organizations/$orgId': typeof AdminOrganizationsOrgIdRoute
  '/admin/subscriptions/audit': typeof AdminSubscriptionsAuditRoute
  '/admin/subscriptions/discounts': typeof AdminSubscriptionsDiscountsRoute
  '/admin/subscriptions/fraud': typeof AdminSubscriptionsFraudRoute
  '/admin/subscriptions/revenue': typeof AdminSubscriptionsRevenueRoute
  '/admin/subscriptions/stripe-events': typeof AdminSubscriptionsStripeEventsRoute
  '/admin/subscriptions/sync': typeof AdminSubscriptionsSyncRoute
  '/admin/support/$ticketId': typeof AdminSupportTicketIdRoute
  '/admin/teams/$teamId': typeof AdminTeamsTeamIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/users/unverified': typeof AdminUsersUnverifiedRoute
  '/admin/finance/': typeof AdminFinanceIndexRoute
  '/admin/form-builder/': typeof AdminFormBuilderIndexRoute
  '/admin/help-kb/': typeof AdminHelpKbIndexRoute
  '/admin/organizations/': typeof AdminOrganizationsIndexRoute
  '/admin/subscriptions/': typeof AdminSubscriptionsIndexRoute
  '/admin/support/': typeof AdminSupportIndexRoute
  '/admin/teams/': typeof AdminTeamsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/admin/finance/reference-accounts/$templateId': typeof AdminFinanceReferenceAccountsTemplateIdRouteWithChildren
  '/admin/finance/reference-accounts/new': typeof AdminFinanceReferenceAccountsNewRoute
  '/admin/help-kb/$articleId/edit': typeof AdminHelpKbArticleIdEditRoute
  '/admin/subscriptions/addons/$addonKey': typeof AdminSubscriptionsAddonsAddonKeyRoute
  '/admin/subscriptions/plans/$planId': typeof AdminSubscriptionsPlansPlanIdRoute
  '/admin/finance/bank-provider-credentials/': typeof AdminFinanceBankProviderCredentialsIndexRoute
  '/admin/finance/reference-accounts/': typeof AdminFinanceReferenceAccountsIndexRoute
  '/admin/subscriptions/addons/': typeof AdminSubscriptionsAddonsIndexRoute
  '/admin/subscriptions/plans/': typeof AdminSubscriptionsPlansIndexRoute
  '/admin/finance/reference-accounts/$templateId/edit': typeof AdminFinanceReferenceAccountsTemplateIdEditRoute
  '/admin/finance/reference-accounts/$templateId/': typeof AdminFinanceReferenceAccountsTemplateIdIndexRoute
  '/admin/finance/reference-accounts/$templateId/accounts/new': typeof AdminFinanceReferenceAccountsTemplateIdAccountsNewRoute
  '/admin/finance/reference-accounts/$templateId/accounts/$accountId/edit': typeof AdminFinanceReferenceAccountsTemplateIdAccountsAccountIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/authentication'
    | '/admin/ai-budget'
    | '/admin/analytics'
    | '/admin/cms-users'
    | '/admin/feature-flags'
    | '/admin/finance'
    | '/admin/help-kb'
    | '/admin/memory-health'
    | '/admin/profile'
    | '/admin/settings'
    | '/admin/subscriptions'
    | '/admin/system-health'
    | '/authentication/change-password'
    | '/authentication/email-confirm'
    | '/authentication/forgot-password'
    | '/authentication/login'
    | '/authentication/mfa'
    | '/authentication/oauth-callback'
    | '/authentication/reset-password'
    | '/authentication/set-cms-password'
    | '/authentication/set-password'
    | '/authentication/signup'
    | '/authentication/verify-email'
    | '/admin/'
    | '/admin/form-builder/$templateId'
    | '/admin/help-kb/media'
    | '/admin/help-kb/new'
    | '/admin/help-kb/queries'
    | '/admin/organizations/$orgId'
    | '/admin/subscriptions/audit'
    | '/admin/subscriptions/discounts'
    | '/admin/subscriptions/fraud'
    | '/admin/subscriptions/revenue'
    | '/admin/subscriptions/stripe-events'
    | '/admin/subscriptions/sync'
    | '/admin/support/$ticketId'
    | '/admin/teams/$teamId'
    | '/admin/users/$userId'
    | '/admin/users/unverified'
    | '/admin/finance/'
    | '/admin/form-builder/'
    | '/admin/help-kb/'
    | '/admin/organizations/'
    | '/admin/subscriptions/'
    | '/admin/support/'
    | '/admin/teams/'
    | '/admin/users/'
    | '/admin/finance/reference-accounts/$templateId'
    | '/admin/finance/reference-accounts/new'
    | '/admin/help-kb/$articleId/edit'
    | '/admin/subscriptions/addons/$addonKey'
    | '/admin/subscriptions/plans/$planId'
    | '/admin/finance/bank-provider-credentials/'
    | '/admin/finance/reference-accounts/'
    | '/admin/subscriptions/addons/'
    | '/admin/subscriptions/plans/'
    | '/admin/finance/reference-accounts/$templateId/edit'
    | '/admin/finance/reference-accounts/$templateId/'
    | '/admin/finance/reference-accounts/$templateId/accounts/new'
    | '/admin/finance/reference-accounts/$templateId/accounts/$accountId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/authentication'
    | '/admin/ai-budget'
    | '/admin/analytics'
    | '/admin/cms-users'
    | '/admin/feature-flags'
    | '/admin/memory-health'
    | '/admin/profile'
    | '/admin/settings'
    | '/admin/system-health'
    | '/authentication/change-password'
    | '/authentication/email-confirm'
    | '/authentication/forgot-password'
    | '/authentication/login'
    | '/authentication/mfa'
    | '/authentication/oauth-callback'
    | '/authentication/reset-password'
    | '/authentication/set-cms-password'
    | '/authentication/set-password'
    | '/authentication/signup'
    | '/authentication/verify-email'
    | '/admin'
    | '/admin/form-builder/$templateId'
    | '/admin/help-kb/media'
    | '/admin/help-kb/new'
    | '/admin/help-kb/queries'
    | '/admin/organizations/$orgId'
    | '/admin/subscriptions/audit'
    | '/admin/subscriptions/discounts'
    | '/admin/subscriptions/fraud'
    | '/admin/subscriptions/revenue'
    | '/admin/subscriptions/stripe-events'
    | '/admin/subscriptions/sync'
    | '/admin/support/$ticketId'
    | '/admin/teams/$teamId'
    | '/admin/users/$userId'
    | '/admin/users/unverified'
    | '/admin/finance'
    | '/admin/form-builder'
    | '/admin/help-kb'
    | '/admin/organizations'
    | '/admin/subscriptions'
    | '/admin/support'
    | '/admin/teams'
    | '/admin/users'
    | '/admin/finance/reference-accounts/new'
    | '/admin/help-kb/$articleId/edit'
    | '/admin/subscriptions/addons/$addonKey'
    | '/admin/subscriptions/plans/$planId'
    | '/admin/finance/bank-provider-credentials'
    | '/admin/finance/reference-accounts'
    | '/admin/subscriptions/addons'
    | '/admin/subscriptions/plans'
    | '/admin/finance/reference-accounts/$templateId/edit'
    | '/admin/finance/reference-accounts/$templateId'
    | '/admin/finance/reference-accounts/$templateId/accounts/new'
    | '/admin/finance/reference-accounts/$templateId/accounts/$accountId/edit'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/authentication'
    | '/admin/ai-budget'
    | '/admin/analytics'
    | '/admin/cms-users'
    | '/admin/feature-flags'
    | '/admin/finance'
    | '/admin/help-kb'
    | '/admin/memory-health'
    | '/admin/profile'
    | '/admin/settings'
    | '/admin/subscriptions'
    | '/admin/system-health'
    | '/authentication/change-password'
    | '/authentication/email-confirm'
    | '/authentication/forgot-password'
    | '/authentication/login'
    | '/authentication/mfa'
    | '/authentication/oauth-callback'
    | '/authentication/reset-password'
    | '/authentication/set-cms-password'
    | '/authentication/set-password'
    | '/authentication/signup'
    | '/authentication/verify-email'
    | '/admin/'
    | '/admin/form-builder/$templateId'
    | '/admin/help-kb/media'
    | '/admin/help-kb/new'
    | '/admin/help-kb/queries'
    | '/admin/organizations/$orgId'
    | '/admin/subscriptions/audit'
    | '/admin/subscriptions/discounts'
    | '/admin/subscriptions/fraud'
    | '/admin/subscriptions/revenue'
    | '/admin/subscriptions/stripe-events'
    | '/admin/subscriptions/sync'
    | '/admin/support/$ticketId'
    | '/admin/teams/$teamId'
    | '/admin/users/$userId'
    | '/admin/users/unverified'
    | '/admin/finance/'
    | '/admin/form-builder/'
    | '/admin/help-kb/'
    | '/admin/organizations/'
    | '/admin/subscriptions/'
    | '/admin/support/'
    | '/admin/teams/'
    | '/admin/users/'
    | '/admin/finance/reference-accounts/$templateId'
    | '/admin/finance/reference-accounts/new'
    | '/admin/help-kb/$articleId/edit'
    | '/admin/subscriptions/addons/$addonKey'
    | '/admin/subscriptions/plans/$planId'
    | '/admin/finance/bank-provider-credentials/'
    | '/admin/finance/reference-accounts/'
    | '/admin/subscriptions/addons/'
    | '/admin/subscriptions/plans/'
    | '/admin/finance/reference-accounts/$templateId/edit'
    | '/admin/finance/reference-accounts/$templateId/'
    | '/admin/finance/reference-accounts/$templateId/accounts/new'
    | '/admin/finance/reference-accounts/$templateId/accounts/$accountId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AuthenticationRoute: typeof AuthenticationRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authentication': {
      id: '/authentication'
      path: '/authentication'
      fullPath: '/authentication'
      preLoaderRoute: typeof AuthenticationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/ai-budget': {
      id: '/admin/ai-budget'
      path: '/ai-budget'
      fullPath: '/admin/ai-budget'
      preLoaderRoute: typeof AdminAiBudgetRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/cms-users': {
      id: '/admin/cms-users'
      path: '/cms-users'
      fullPath: '/admin/cms-users'
      preLoaderRoute: typeof AdminCmsUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/feature-flags': {
      id: '/admin/feature-flags'
      path: '/feature-flags'
      fullPath: '/admin/feature-flags'
      preLoaderRoute: typeof AdminFeatureFlagsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/finance': {
      id: '/admin/finance'
      path: '/finance'
      fullPath: '/admin/finance'
      preLoaderRoute: typeof AdminFinanceRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/help-kb': {
      id: '/admin/help-kb'
      path: '/help-kb'
      fullPath: '/admin/help-kb'
      preLoaderRoute: typeof AdminHelpKbRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/memory-health': {
      id: '/admin/memory-health'
      path: '/memory-health'
      fullPath: '/admin/memory-health'
      preLoaderRoute: typeof AdminMemoryHealthRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/profile': {
      id: '/admin/profile'
      path: '/profile'
      fullPath: '/admin/profile'
      preLoaderRoute: typeof AdminProfileRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/subscriptions': {
      id: '/admin/subscriptions'
      path: '/subscriptions'
      fullPath: '/admin/subscriptions'
      preLoaderRoute: typeof AdminSubscriptionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/system-health': {
      id: '/admin/system-health'
      path: '/system-health'
      fullPath: '/admin/system-health'
      preLoaderRoute: typeof AdminSystemHealthRouteImport
      parentRoute: typeof AdminRoute
    }
    '/authentication/change-password': {
      id: '/authentication/change-password'
      path: '/change-password'
      fullPath: '/authentication/change-password'
      preLoaderRoute: typeof AuthenticationChangePasswordRouteImport
      parentRoute: typeof AuthenticationRoute
    }
    '/authentication/email-confirm': {
      id: '/authentication/email-confirm'
      path: '/email-confirm'
      fullPath: '/authentication/email-confirm'
      preLoaderRoute: typeof AuthenticationEmailConfirmRouteImport
      parentRoute: typeof AuthenticationRoute
    }
    '/authentication/forgot-password': {
      id: '/authentication/forgot-password'
      path: '/forgot-password'
      fullPath: '/authentication/forgot-password'
      preLoaderRoute: typeof AuthenticationForgotPasswordRouteImport
      parentRoute: typeof AuthenticationRoute
    }
    '/authentication/login': {
      id: '/authentication/login'
      path: '/login'
      fullPath: '/authentication/login'
      preLoaderRoute: typeof AuthenticationLoginRouteImport
      parentRoute: typeof AuthenticationRoute
    }
    '/authentication/mfa': {
      id: '/authentication/mfa'
      path: '/mfa'
      fullPath: '/authentication/mfa'
      preLoaderRoute: typeof AuthenticationMfaRouteImport
      parentRoute: typeof AuthenticationRoute
    }
    '/authentication/oauth-callback': {
      id: '/authentication/oauth-callback'
      path: '/oauth-callback'
      fullPath: '/authentication/oauth-callback'
      preLoaderRoute: typeof AuthenticationOauthCallbackRouteImport
      parentRoute: typeof AuthenticationRoute
    }
    '/authentication/reset-password': {
      id: '/authentication/reset-password'
      path: '/reset-password'
      fullPath: '/authentication/reset-password'
      preLoaderRoute: typeof AuthenticationResetPasswordRouteImport
      parentRoute: typeof AuthenticationRoute
    }
    '/authentication/set-cms-password': {
      id: '/authentication/set-cms-password'
      path: '/set-cms-password'
      fullPath: '/authentication/set-cms-password'
      preLoaderRoute: typeof AuthenticationSetCmsPasswordRouteImport
      parentRoute: typeof AuthenticationRoute
    }
    '/authentication/set-password': {
      id: '/authentication/set-password'
      path: '/set-password'
      fullPath: '/authentication/set-password'
      preLoaderRoute: typeof AuthenticationSetPasswordRouteImport
      parentRoute: typeof AuthenticationRoute
    }
    '/authentication/signup': {
      id: '/authentication/signup'
      path: '/signup'
      fullPath: '/authentication/signup'
      preLoaderRoute: typeof AuthenticationSignupRouteImport
      parentRoute: typeof AuthenticationRoute
    }
    '/authentication/verify-email': {
      id: '/authentication/verify-email'
      path: '/verify-email'
      fullPath: '/authentication/verify-email'
      preLoaderRoute: typeof AuthenticationVerifyEmailRouteImport
      parentRoute: typeof AuthenticationRoute
    }
    '/admin/finance/': {
      id: '/admin/finance/'
      path: '/'
      fullPath: '/admin/finance/'
      preLoaderRoute: typeof AdminFinanceIndexRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/form-builder/': {
      id: '/admin/form-builder/'
      path: '/form-builder'
      fullPath: '/admin/form-builder/'
      preLoaderRoute: typeof AdminFormBuilderIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/form-builder/$templateId': {
      id: '/admin/form-builder/$templateId'
      path: '/form-builder/$templateId'
      fullPath: '/admin/form-builder/$templateId'
      preLoaderRoute: typeof AdminFormBuilderTemplateIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/help-kb/': {
      id: '/admin/help-kb/'
      path: '/'
      fullPath: '/admin/help-kb/'
      preLoaderRoute: typeof AdminHelpKbIndexRouteImport
      parentRoute: typeof AdminHelpKbRoute
    }
    '/admin/help-kb/media': {
      id: '/admin/help-kb/media'
      path: '/media'
      fullPath: '/admin/help-kb/media'
      preLoaderRoute: typeof AdminHelpKbMediaRouteImport
      parentRoute: typeof AdminHelpKbRoute
    }
    '/admin/help-kb/new': {
      id: '/admin/help-kb/new'
      path: '/new'
      fullPath: '/admin/help-kb/new'
      preLoaderRoute: typeof AdminHelpKbNewRouteImport
      parentRoute: typeof AdminHelpKbRoute
    }
    '/admin/help-kb/queries': {
      id: '/admin/help-kb/queries'
      path: '/queries'
      fullPath: '/admin/help-kb/queries'
      preLoaderRoute: typeof AdminHelpKbQueriesRouteImport
      parentRoute: typeof AdminHelpKbRoute
    }
    '/admin/organizations/': {
      id: '/admin/organizations/'
      path: '/organizations'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof AdminOrganizationsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/organizations/$orgId': {
      id: '/admin/organizations/$orgId'
      path: '/organizations/$orgId'
      fullPath: '/admin/organizations/$orgId'
      preLoaderRoute: typeof AdminOrganizationsOrgIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/subscriptions/': {
      id: '/admin/subscriptions/'
      path: '/'
      fullPath: '/admin/subscriptions/'
      preLoaderRoute: typeof AdminSubscriptionsIndexRouteImport
      parentRoute: typeof AdminSubscriptionsRoute
    }
    '/admin/subscriptions/audit': {
      id: '/admin/subscriptions/audit'
      path: '/audit'
      fullPath: '/admin/subscriptions/audit'
      preLoaderRoute: typeof AdminSubscriptionsAuditRouteImport
      parentRoute: typeof AdminSubscriptionsRoute
    }
    '/admin/subscriptions/discounts': {
      id: '/admin/subscriptions/discounts'
      path: '/discounts'
      fullPath: '/admin/subscriptions/discounts'
      preLoaderRoute: typeof AdminSubscriptionsDiscountsRouteImport
      parentRoute: typeof AdminSubscriptionsRoute
    }
    '/admin/subscriptions/fraud': {
      id: '/admin/subscriptions/fraud'
      path: '/fraud'
      fullPath: '/admin/subscriptions/fraud'
      preLoaderRoute: typeof AdminSubscriptionsFraudRouteImport
      parentRoute: typeof AdminSubscriptionsRoute
    }
    '/admin/subscriptions/revenue': {
      id: '/admin/subscriptions/revenue'
      path: '/revenue'
      fullPath: '/admin/subscriptions/revenue'
      preLoaderRoute: typeof AdminSubscriptionsRevenueRouteImport
      parentRoute: typeof AdminSubscriptionsRoute
    }
    '/admin/subscriptions/stripe-events': {
      id: '/admin/subscriptions/stripe-events'
      path: '/stripe-events'
      fullPath: '/admin/subscriptions/stripe-events'
      preLoaderRoute: typeof AdminSubscriptionsStripeEventsRouteImport
      parentRoute: typeof AdminSubscriptionsRoute
    }
    '/admin/subscriptions/sync': {
      id: '/admin/subscriptions/sync'
      path: '/sync'
      fullPath: '/admin/subscriptions/sync'
      preLoaderRoute: typeof AdminSubscriptionsSyncRouteImport
      parentRoute: typeof AdminSubscriptionsRoute
    }
    '/admin/support/': {
      id: '/admin/support/'
      path: '/support'
      fullPath: '/admin/support/'
      preLoaderRoute: typeof AdminSupportIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/support/$ticketId': {
      id: '/admin/support/$ticketId'
      path: '/support/$ticketId'
      fullPath: '/admin/support/$ticketId'
      preLoaderRoute: typeof AdminSupportTicketIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/teams/': {
      id: '/admin/teams/'
      path: '/teams'
      fullPath: '/admin/teams/'
      preLoaderRoute: typeof AdminTeamsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/teams/$teamId': {
      id: '/admin/teams/$teamId'
      path: '/teams/$teamId'
      fullPath: '/admin/teams/$teamId'
      preLoaderRoute: typeof AdminTeamsTeamIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users/$userId': {
      id: '/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AdminUsersUserIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users/unverified': {
      id: '/admin/users/unverified'
      path: '/users/unverified'
      fullPath: '/admin/users/unverified'
      preLoaderRoute: typeof AdminUsersUnverifiedRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/finance/bank-provider-credentials/': {
      id: '/admin/finance/bank-provider-credentials/'
      path: '/bank-provider-credentials'
      fullPath: '/admin/finance/bank-provider-credentials/'
      preLoaderRoute: typeof AdminFinanceBankProviderCredentialsIndexRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/reference-accounts/': {
      id: '/admin/finance/reference-accounts/'
      path: '/reference-accounts'
      fullPath: '/admin/finance/reference-accounts/'
      preLoaderRoute: typeof AdminFinanceReferenceAccountsIndexRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/reference-accounts/$templateId': {
      id: '/admin/finance/reference-accounts/$templateId'
      path: '/reference-accounts/$templateId'
      fullPath: '/admin/finance/reference-accounts/$templateId'
      preLoaderRoute: typeof AdminFinanceReferenceAccountsTemplateIdRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/finance/reference-accounts/new': {
      id: '/admin/finance/reference-accounts/new'
      path: '/reference-accounts/new'
      fullPath: '/admin/finance/reference-accounts/new'
      preLoaderRoute: typeof AdminFinanceReferenceAccountsNewRouteImport
      parentRoute: typeof AdminFinanceRoute
    }
    '/admin/help-kb/$articleId/edit': {
      id: '/admin/help-kb/$articleId/edit'
      path: '/$articleId/edit'
      fullPath: '/admin/help-kb/$articleId/edit'
      preLoaderRoute: typeof AdminHelpKbArticleIdEditRouteImport
      parentRoute: typeof AdminHelpKbRoute
    }
    '/admin/subscriptions/addons/': {
      id: '/admin/subscriptions/addons/'
      path: '/addons'
      fullPath: '/admin/subscriptions/addons/'
      preLoaderRoute: typeof AdminSubscriptionsAddonsIndexRouteImport
      parentRoute: typeof AdminSubscriptionsRoute
    }
    '/admin/subscriptions/addons/$addonKey': {
      id: '/admin/subscriptions/addons/$addonKey'
      path: '/addons/$addonKey'
      fullPath: '/admin/subscriptions/addons/$addonKey'
      preLoaderRoute: typeof AdminSubscriptionsAddonsAddonKeyRouteImport
      parentRoute: typeof AdminSubscriptionsRoute
    }
    '/admin/subscriptions/plans/': {
      id: '/admin/subscriptions/plans/'
      path: '/plans'
      fullPath: '/admin/subscriptions/plans/'
      preLoaderRoute: typeof AdminSubscriptionsPlansIndexRouteImport
      parentRoute: typeof AdminSubscriptionsRoute
    }
    '/admin/subscriptions/plans/$planId': {
      id: '/admin/subscriptions/plans/$planId'
      path: '/plans/$planId'
      fullPath: '/admin/subscriptions/plans/$planId'
      preLoaderRoute: typeof AdminSubscriptionsPlansPlanIdRouteImport
      parentRoute: typeof AdminSubscriptionsRoute
    }
    '/admin/finance/reference-accounts/$templateId/': {
      id: '/admin/finance/reference-accounts/$templateId/'
      path: '/'
      fullPath: '/admin/finance/reference-accounts/$templateId/'
      preLoaderRoute: typeof AdminFinanceReferenceAccountsTemplateIdIndexRouteImport
      parentRoute: typeof AdminFinanceReferenceAccountsTemplateIdRoute
    }
    '/admin/finance/reference-accounts/$templateId/edit': {
      id: '/admin/finance/reference-accounts/$templateId/edit'
      path: '/edit'
      fullPath: '/admin/finance/reference-accounts/$templateId/edit'
      preLoaderRoute: typeof AdminFinanceReferenceAccountsTemplateIdEditRouteImport
      parentRoute: typeof AdminFinanceReferenceAccountsTemplateIdRoute
    }
    '/admin/finance/reference-accounts/$templateId/accounts/new': {
      id: '/admin/finance/reference-accounts/$templateId/accounts/new'
      path: '/accounts/new'
      fullPath: '/admin/finance/reference-accounts/$templateId/accounts/new'
      preLoaderRoute: typeof AdminFinanceReferenceAccountsTemplateIdAccountsNewRouteImport
      parentRoute: typeof AdminFinanceReferenceAccountsTemplateIdRoute
    }
    '/admin/finance/reference-accounts/$templateId/accounts/$accountId/edit': {
      id: '/admin/finance/reference-accounts/$templateId/accounts/$accountId/edit'
      path: '/accounts/$accountId/edit'
      fullPath: '/admin/finance/reference-accounts/$templateId/accounts/$accountId/edit'
      preLoaderRoute: typeof AdminFinanceReferenceAccountsTemplateIdAccountsAccountIdEditRouteImport
      parentRoute: typeof AdminFinanceReferenceAccountsTemplateIdRoute
    }
  }
}

interface AdminFinanceReferenceAccountsTemplateIdRouteChildren {
  AdminFinanceReferenceAccountsTemplateIdEditRoute: typeof AdminFinanceReferenceAccountsTemplateIdEditRoute
  AdminFinanceReferenceAccountsTemplateIdIndexRoute: typeof AdminFinanceReferenceAccountsTemplateIdIndexRoute
  AdminFinanceReferenceAccountsTemplateIdAccountsNewRoute: typeof AdminFinanceReferenceAccountsTemplateIdAccountsNewRoute
  AdminFinanceReferenceAccountsTemplateIdAccountsAccountIdEditRoute: typeof AdminFinanceReferenceAccountsTemplateIdAccountsAccountIdEditRoute
}

const AdminFinanceReferenceAccountsTemplateIdRouteChildren: AdminFinanceReferenceAccountsTemplateIdRouteChildren =
  {
    AdminFinanceReferenceAccountsTemplateIdEditRoute:
      AdminFinanceReferenceAccountsTemplateIdEditRoute,
    AdminFinanceReferenceAccountsTemplateIdIndexRoute:
      AdminFinanceReferenceAccountsTemplateIdIndexRoute,
    AdminFinanceReferenceAccountsTemplateIdAccountsNewRoute:
      AdminFinanceReferenceAccountsTemplateIdAccountsNewRoute,
    AdminFinanceReferenceAccountsTemplateIdAccountsAccountIdEditRoute:
      AdminFinanceReferenceAccountsTemplateIdAccountsAccountIdEditRoute,
  }

const AdminFinanceReferenceAccountsTemplateIdRouteWithChildren =
  AdminFinanceReferenceAccountsTemplateIdRoute._addFileChildren(
    AdminFinanceReferenceAccountsTemplateIdRouteChildren,
  )

interface AdminFinanceRouteChildren {
  AdminFinanceIndexRoute: typeof AdminFinanceIndexRoute
  AdminFinanceReferenceAccountsTemplateIdRoute: typeof AdminFinanceReferenceAccountsTemplateIdRouteWithChildren
  AdminFinanceReferenceAccountsNewRoute: typeof AdminFinanceReferenceAccountsNewRoute
  AdminFinanceBankProviderCredentialsIndexRoute: typeof AdminFinanceBankProviderCredentialsIndexRoute
  AdminFinanceReferenceAccountsIndexRoute: typeof AdminFinanceReferenceAccountsIndexRoute
}

const AdminFinanceRouteChildren: AdminFinanceRouteChildren = {
  AdminFinanceIndexRoute: AdminFinanceIndexRoute,
  AdminFinanceReferenceAccountsTemplateIdRoute:
    AdminFinanceReferenceAccountsTemplateIdRouteWithChildren,
  AdminFinanceReferenceAccountsNewRoute: AdminFinanceReferenceAccountsNewRoute,
  AdminFinanceBankProviderCredentialsIndexRoute:
    AdminFinanceBankProviderCredentialsIndexRoute,
  AdminFinanceReferenceAccountsIndexRoute:
    AdminFinanceReferenceAccountsIndexRoute,
}

const AdminFinanceRouteWithChildren = AdminFinanceRoute._addFileChildren(
  AdminFinanceRouteChildren,
)

interface AdminHelpKbRouteChildren {
  AdminHelpKbMediaRoute: typeof AdminHelpKbMediaRoute
  AdminHelpKbNewRoute: typeof AdminHelpKbNewRoute
  AdminHelpKbQueriesRoute: typeof AdminHelpKbQueriesRoute
  AdminHelpKbIndexRoute: typeof AdminHelpKbIndexRoute
  AdminHelpKbArticleIdEditRoute: typeof AdminHelpKbArticleIdEditRoute
}

const AdminHelpKbRouteChildren: AdminHelpKbRouteChildren = {
  AdminHelpKbMediaRoute: AdminHelpKbMediaRoute,
  AdminHelpKbNewRoute: AdminHelpKbNewRoute,
  AdminHelpKbQueriesRoute: AdminHelpKbQueriesRoute,
  AdminHelpKbIndexRoute: AdminHelpKbIndexRoute,
  AdminHelpKbArticleIdEditRoute: AdminHelpKbArticleIdEditRoute,
}

const AdminHelpKbRouteWithChildren = AdminHelpKbRoute._addFileChildren(
  AdminHelpKbRouteChildren,
)

interface AdminSubscriptionsRouteChildren {
  AdminSubscriptionsAuditRoute: typeof AdminSubscriptionsAuditRoute
  AdminSubscriptionsDiscountsRoute: typeof AdminSubscriptionsDiscountsRoute
  AdminSubscriptionsFraudRoute: typeof AdminSubscriptionsFraudRoute
  AdminSubscriptionsRevenueRoute: typeof AdminSubscriptionsRevenueRoute
  AdminSubscriptionsStripeEventsRoute: typeof AdminSubscriptionsStripeEventsRoute
  AdminSubscriptionsSyncRoute: typeof AdminSubscriptionsSyncRoute
  AdminSubscriptionsIndexRoute: typeof AdminSubscriptionsIndexRoute
  AdminSubscriptionsAddonsAddonKeyRoute: typeof AdminSubscriptionsAddonsAddonKeyRoute
  AdminSubscriptionsPlansPlanIdRoute: typeof AdminSubscriptionsPlansPlanIdRoute
  AdminSubscriptionsAddonsIndexRoute: typeof AdminSubscriptionsAddonsIndexRoute
  AdminSubscriptionsPlansIndexRoute: typeof AdminSubscriptionsPlansIndexRoute
}

const AdminSubscriptionsRouteChildren: AdminSubscriptionsRouteChildren = {
  AdminSubscriptionsAuditRoute: AdminSubscriptionsAuditRoute,
  AdminSubscriptionsDiscountsRoute: AdminSubscriptionsDiscountsRoute,
  AdminSubscriptionsFraudRoute: AdminSubscriptionsFraudRoute,
  AdminSubscriptionsRevenueRoute: AdminSubscriptionsRevenueRoute,
  AdminSubscriptionsStripeEventsRoute: AdminSubscriptionsStripeEventsRoute,
  AdminSubscriptionsSyncRoute: AdminSubscriptionsSyncRoute,
  AdminSubscriptionsIndexRoute: AdminSubscriptionsIndexRoute,
  AdminSubscriptionsAddonsAddonKeyRoute: AdminSubscriptionsAddonsAddonKeyRoute,
  AdminSubscriptionsPlansPlanIdRoute: AdminSubscriptionsPlansPlanIdRoute,
  AdminSubscriptionsAddonsIndexRoute: AdminSubscriptionsAddonsIndexRoute,
  AdminSubscriptionsPlansIndexRoute: AdminSubscriptionsPlansIndexRoute,
}

const AdminSubscriptionsRouteWithChildren =
  AdminSubscriptionsRoute._addFileChildren(AdminSubscriptionsRouteChildren)

interface AdminRouteChildren {
  AdminAiBudgetRoute: typeof AdminAiBudgetRoute
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminCmsUsersRoute: typeof AdminCmsUsersRoute
  AdminFeatureFlagsRoute: typeof AdminFeatureFlagsRoute
  AdminFinanceRoute: typeof AdminFinanceRouteWithChildren
  AdminHelpKbRoute: typeof AdminHelpKbRouteWithChildren
  AdminMemoryHealthRoute: typeof AdminMemoryHealthRoute
  AdminProfileRoute: typeof AdminProfileRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminSubscriptionsRoute: typeof AdminSubscriptionsRouteWithChildren
  AdminSystemHealthRoute: typeof AdminSystemHealthRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminFormBuilderTemplateIdRoute: typeof AdminFormBuilderTemplateIdRoute
  AdminOrganizationsOrgIdRoute: typeof AdminOrganizationsOrgIdRoute
  AdminSupportTicketIdRoute: typeof AdminSupportTicketIdRoute
  AdminTeamsTeamIdRoute: typeof AdminTeamsTeamIdRoute
  AdminUsersUserIdRoute: typeof AdminUsersUserIdRoute
  AdminUsersUnverifiedRoute: typeof AdminUsersUnverifiedRoute
  AdminFormBuilderIndexRoute: typeof AdminFormBuilderIndexRoute
  AdminOrganizationsIndexRoute: typeof AdminOrganizationsIndexRoute
  AdminSupportIndexRoute: typeof AdminSupportIndexRoute
  AdminTeamsIndexRoute: typeof AdminTeamsIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAiBudgetRoute: AdminAiBudgetRoute,
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminCmsUsersRoute: AdminCmsUsersRoute,
  AdminFeatureFlagsRoute: AdminFeatureFlagsRoute,
  AdminFinanceRoute: AdminFinanceRouteWithChildren,
  AdminHelpKbRoute: AdminHelpKbRouteWithChildren,
  AdminMemoryHealthRoute: AdminMemoryHealthRoute,
  AdminProfileRoute: AdminProfileRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminSubscriptionsRoute: AdminSubscriptionsRouteWithChildren,
  AdminSystemHealthRoute: AdminSystemHealthRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminFormBuilderTemplateIdRoute: AdminFormBuilderTemplateIdRoute,
  AdminOrganizationsOrgIdRoute: AdminOrganizationsOrgIdRoute,
  AdminSupportTicketIdRoute: AdminSupportTicketIdRoute,
  AdminTeamsTeamIdRoute: AdminTeamsTeamIdRoute,
  AdminUsersUserIdRoute: AdminUsersUserIdRoute,
  AdminUsersUnverifiedRoute: AdminUsersUnverifiedRoute,
  AdminFormBuilderIndexRoute: AdminFormBuilderIndexRoute,
  AdminOrganizationsIndexRoute: AdminOrganizationsIndexRoute,
  AdminSupportIndexRoute: AdminSupportIndexRoute,
  AdminTeamsIndexRoute: AdminTeamsIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AuthenticationRouteChildren {
  AuthenticationChangePasswordRoute: typeof AuthenticationChangePasswordRoute
  AuthenticationEmailConfirmRoute: typeof AuthenticationEmailConfirmRoute
  AuthenticationForgotPasswordRoute: typeof AuthenticationForgotPasswordRoute
  AuthenticationLoginRoute: typeof AuthenticationLoginRoute
  AuthenticationMfaRoute: typeof AuthenticationMfaRoute
  AuthenticationOauthCallbackRoute: typeof AuthenticationOauthCallbackRoute
  AuthenticationResetPasswordRoute: typeof AuthenticationResetPasswordRoute
  AuthenticationSetCmsPasswordRoute: typeof AuthenticationSetCmsPasswordRoute
  AuthenticationSetPasswordRoute: typeof AuthenticationSetPasswordRoute
  AuthenticationSignupRoute: typeof AuthenticationSignupRoute
  AuthenticationVerifyEmailRoute: typeof AuthenticationVerifyEmailRoute
}

const AuthenticationRouteChildren: AuthenticationRouteChildren = {
  AuthenticationChangePasswordRoute: AuthenticationChangePasswordRoute,
  AuthenticationEmailConfirmRoute: AuthenticationEmailConfirmRoute,
  AuthenticationForgotPasswordRoute: AuthenticationForgotPasswordRoute,
  AuthenticationLoginRoute: AuthenticationLoginRoute,
  AuthenticationMfaRoute: AuthenticationMfaRoute,
  AuthenticationOauthCallbackRoute: AuthenticationOauthCallbackRoute,
  AuthenticationResetPasswordRoute: AuthenticationResetPasswordRoute,
  AuthenticationSetCmsPasswordRoute: AuthenticationSetCmsPasswordRoute,
  AuthenticationSetPasswordRoute: AuthenticationSetPasswordRoute,
  AuthenticationSignupRoute: AuthenticationSignupRoute,
  AuthenticationVerifyEmailRoute: AuthenticationVerifyEmailRoute,
}

const AuthenticationRouteWithChildren = AuthenticationRoute._addFileChildren(
  AuthenticationRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AuthenticationRoute: AuthenticationRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
